
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialRequestForPurchaseGrid extends _Ext.GridBase<MaterialRequestItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialRequestItems'; }
        protected getDialogType() { return MaterialRequestItemsDialog; }
        protected getIdProperty() { return MaterialRequestItemsRow.idProperty; }
        protected getInsertPermission() { return MaterialRequestItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialRequestItemsRow.localTextPrefix; }
        protected getService() { return MaterialRequestItemsService.baseUrl; }

        private autoSize; 
        withBom: boolean;
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };
        //withBom: boolean;
        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): MaterialRequestItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 
        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    }

}